
define('text!templates/modules/supervisor/supervisor-icon.html',[],function () { return '<div class="icon-admin" data-toggle="tooltip" title="{{#t}}messages:tooltip-supervisor{{/t}}">\n    <span class="fa-stack">\n      <i class="fa fa-circle fa-stack-2x"></i>\n      <i class="fa fa-bolt fa-stack-1x fa-inverse"></i>\n    </span>\n</div>\n';});

